import { render, staticRenderFns } from "./ImportOrdersFormSimple.vue?vue&type=template&id=25122b10"
import script from "./ImportOrdersFormSimple.vue?vue&type=script&lang=js"
export * from "./ImportOrdersFormSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports